import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducers from 'src/stores/reducer'

export const store = createStore(reducers, {}, applyMiddleware(thunk))
